import { render } from "./CreateCompteClient.vue?vue&type=template&id=4d24089f"
import script from "./CreateCompteClient.vue?vue&type=script&lang=js"
export * from "./CreateCompteClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__